/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiPostalCodeLookup, EnumCountry } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of PostalCodesController.
 */
export class PostalCodesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /postal_codes:query
     */
    public lookup(country: EnumCountry, zipCode: string): Promise<Result<ApiPostalCodeLookup>> {
        const query = new URLSearchParams();
        query.set('country', `${country}`);
        query.set('zipCode', `${zipCode}`);

        return this.http.get<Result<ApiPostalCodeLookup>>('/postal_codes:query', query);
    }
}
